// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/style." + {"196":"f014cea2e21fdb4cdf28","909":"54f46d092ba74d12c2cd"}[chunkId] + ".css";
};